import { Box } from '@factorialco/deprecated-design-system'

import type { GraphQLEmployee } from 'modules/org_chart/lib/employeeUtils'

import DirectReports from './DirectReports'
import Overview from './Overview'

const ReportsDetails = ({
  allEmployees,
  hasLegacyJobCatalog,
}: {
  allEmployees: GraphQLEmployee[]
  hasLegacyJobCatalog: boolean
}) => {
  return (
    <Box>
      <Overview allEmployees={allEmployees} />

      <DirectReports allEmployees={allEmployees} hasLegacyJobCatalog={hasLegacyJobCatalog} />
    </Box>
  )
}

export default ReportsDetails
